import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { LayoutService } from '../../../../RefModules/_metronic/core';
import { SubheaderService } from '../../../../RefModules/_metronic/partials/layout';
import { BreadcrumbItemModel } from '../../../../RefModules/_metronic/partials/layout/subheader/_models/breadcrumb-item.model';
import { SubHeaderData } from '../../../informate/models/sub-header-data';
import { AddTaggedItemModalComponent } from '../plant-manager/components/add-tagged-item-modal/add-tagged-item-modal.component';
import { PlantmanagerService } from '../plant-manager/services/plantmanager.service';
import { UserUtilityService } from 'src/app/services';
import { userActions } from 'src/app/models/enums/user-permissions.enum';
import { Router } from '@angular/router';
import { DocumentUploadComponent } from '../plant-manager/components/document-upload/document-upload.component';
import { LinkEntityType } from '../project-manager/enums/LinkEntityType.enum';
import { ConnectorChild } from '../plant-manager/models/plant-manager.model';

@Component({
    selector: 'app-idms-sub-header',
    templateUrl: './idms-sub-header.component.html',
    styleUrls: ['./idms-sub-header.component.scss'],
})
export class IdmsSubHeaderComponent implements OnInit, OnChanges {
    @Input() headerData: SubHeaderData;
    @Input() generalTab: string;
    @Input() tabIndex: number;
    @Input() currentTaggedItem: any;
    @Input() ConnectorChildrenList: ConnectorChild[] = [];
    @Output() isProjecAdded: EventEmitter<boolean> = new EventEmitter<boolean>();

    breadcrumbs$: Observable<BreadcrumbItemModel[]>;
    imgSrc: string;
    subheaderCSSClasses = '';
    subheaderContainerCSSClasses = '';
    subheaderMobileToggle = false;
    subheaderDisplayDesc = false;
    subheaderDisplayDaterangepicker = false;
    title$: Observable<string>;
    description$: Observable<string>;
    temp = false;
    hideButtons: boolean = false;
    selectedTaggedItem: any;
    isAddEnabled: boolean = false;
    isAddPermission: boolean;
    currentOrganizationName: string;
    currentInstanceName: string;
    currentAssetType: string;

    constructor(
        private layout: LayoutService,
        private subheader: SubheaderService,
        private cd: ChangeDetectorRef,
        private modalService: NgbModal,
        private userUtilityServices: UserUtilityService,
        public router: Router
    ) {
        this.title$ = this.subheader.titleSubject.asObservable();
        this.breadcrumbs$ = this.subheader.breadCrumbsSubject.asObservable();
        this.description$ = this.subheader.descriptionSubject.asObservable();
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.imgSrc = this.headerData.defaultImageSrc;
        if (this.currentTaggedItem?.selecteddata?.taggedItemType == 'Joint') {
            this.isAddEnabled = false;
            this.cd.detectChanges();
        } else {
            this.isAddEnabled = true;
        }
        if (this.currentTaggedItem?.selecteddata) {
            this.selectedTaggedItem = this.currentTaggedItem.selecteddata;
        } else {
            this.selectedTaggedItem = null;
        }
    }

    ngOnInit() {
        this.subheaderCSSClasses = this.layout.getStringCSSClasses('subheader');
        this.subheaderContainerCSSClasses = this.layout.getStringCSSClasses('subheader_container');
        this.subheaderMobileToggle = this.layout.getProp('subheader.mobileToggle');
        this.subheaderDisplayDesc = this.layout.getProp('subheader.displayDesc');
        this.subheaderDisplayDaterangepicker = this.layout.getProp('subheader.displayDaterangepicker');
        this.Initialize();

        if (localStorage.getItem('currentInstanceName')) {
            this.currentOrganizationName = localStorage.getItem('selectedOrganizationName');
        }
        if (localStorage.getItem('selectedOrganizationName')) {
            this.currentInstanceName = localStorage.getItem('currentInstanceName');
        }
        if (localStorage.getItem('currentAssetType')) {
            this.currentAssetType = localStorage.getItem('currentAssetType');
        }
    }

    async Initialize(): Promise<void> {
        this.checkPermission();
        if (this.currentTaggedItem?.selecteddata) {
            this.cd.detectChanges();
            this.selectedTaggedItem = this.currentTaggedItem?.selecteddata;
            if (this.currentTaggedItem.selecteddata.taggedItemType == 'Joint') {
                this.isAddEnabled = false;
                this.cd.detectChanges();
            } else {
                this.isAddEnabled = true; //await this.userUtilityServices.checkUserPermissionDataAndRoute('plantmanager/:isRedirect', userActions.Create);
            }
        } else {
            this.selectedTaggedItem = null;
            this.isAddEnabled = true;
            this.cd.detectChanges();
        }
        this.cd.detectChanges();

        this.isAddEnabled = await this.userUtilityServices.checkUserPermissionDataAndRoute('plantmanager/:isRedirect', userActions.Create);
    }

    async checkPermission() {
        this.isAddPermission = await this.userUtilityServices.checkUserPermissionDataAndRoute('plantmanager/:isRedirect', userActions.Create);
    }

    onMouseOver(): void {
        this.imgSrc = this.headerData.mouseOverImageSrc;
    }

    onMouseOut(): void {
        this.imgSrc = this.headerData.defaultImageSrc;
    }

    open() {
        this.modalService.open(AddTaggedItemModalComponent, {
            ariaLabelledBy: 'modal-basic-title',
            size: 'md',
        });
    }

    shouldShowAddNewProjects(): boolean {
        const url = this.router.url;
        const basePattern = /^\/idms\/project-manager$/;
        const projectPattern = /^\/idms\/project-manager\/([a-f0-9\-]+)$/;
        const workpackPattern = /^\/idms\/project-manager\/([a-f0-9\-]+)\/workpack\/([a-f0-9\-]+)$/;

        return basePattern.test(url) || projectPattern.test(url) || workpackPattern.test(url);
    }

    uploadDocument() {
        const dialogRef = this.modalService.open(DocumentUploadComponent, {
            size: 'lg',
            backdrop: 'static',
            keyboard: false,
        });
        dialogRef.componentInstance.headingName = this.generalTab;
        dialogRef.componentInstance.modalMode = 'Add';
        dialogRef.componentInstance.LinkEntityId = this.selectedTaggedItem?.taggedItemId;
        dialogRef.componentInstance.linkEntityType = LinkEntityType.TaggedItem;
        dialogRef.componentInstance.Type = 'Document';
    }

    isProjecAddedHandler(event) {
        if (event) {
            this.isProjecAdded.emit(true);
        }
    }
}
